
import { EventBus } from '@/utils/EventBus';

const tooltipControlMixin = {
  data() {
    return {
      isOpen: false,
      isDownPosi: false,
      defaultHeightNum: 300
    }
  },
  computed: {

  },
  mounted() {
    EventBus.$on("close:Tooltip", this.closeTooltip);
    
  },
  methods: {
    tooltipControl(index) {

      if(!this.isOpen) {
        this.openTooltip();
      } else {
        this.closeTooltip();
      }
    },
    emitCloseTooltip(){
      EventBus.$emit("close:Tooltip");
    },
    openTooltip() {
      this.emitCloseTooltip();
      window.addEventListener('click', this.emitCloseTooltip);
      this.isOpen = true;
    },
    closeTooltip() {
      window.removeEventListener('click', this.emitCloseTooltip);
      this.isOpen = false;
    },

  },
}

export default tooltipControlMixin;